import { call, put } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import {
  checkSavedCourseActions,
  deleteSavedCourseActions,
  exploreCourseActions,
} from "../slices";
import { showFailureToast } from "@helpers";

function* updateSaveStatus(payload, isSave) {
  if (isSave) {
    yield put(checkSavedCourseActions.markSaved());
  } else {
    yield put(checkSavedCourseActions.markUnsaved());
  }
  yield put(
    exploreCourseActions.updateSaveStatus({
      ...payload,
      isSave,
    })
  );
}

function* deleteSavedCourseWorker({ payload }) {
  yield put(deleteSavedCourseActions.pending(payload));
  // Update redux
  yield call(updateSaveStatus, payload, false);

  try {
    const response = yield call(courseAPI.deleteSavedCourse, payload.courseId);
    yield put(deleteSavedCourseActions.success(response));

    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(deleteSavedCourseActions.failure(error));
    yield call(updateSaveStatus, payload, true);
    yield call(
      showFailureToast,
      error?.message || "Removing from the saved list failed!"
    );
    // TODO: handle callback | onFailure
  }
}

function* deleteAllSavedCoursesWorker() {
  yield put(
    exploreCourseActions.updateSaveStatusAll({
      isSave: false,
    })
  );
  try {
    const response = yield call(courseAPI.deleteAllSavedCourses);
    yield put(deleteSavedCourseActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(deleteSavedCourseActions.failure(error));
    yield put(
      exploreCourseActions.updateSaveStatusAll({
        isSave: true,
      })
    );
    yield call(
      showFailureToast,
      error?.message || "Removing from the saved list failed!"
    );
    // TODO: handle callback | onFailure
  }
}

export { deleteSavedCourseWorker, deleteAllSavedCoursesWorker };
